import StopsRow from './container';

export default StopsRow;
